import React from "react";
import PropTypes from "utils/propTypes";

import bn from "utils/bemnames";

import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { Link } from "react-router-dom";

import Typography from "./Typography";

const bem = bn.create("page");

const Page = ({
  title,
  breadcrumbs,
  tag: Tag,
  className,
  children,
  action,
  ...restProps
}) => {
  const classes = bem.b("px-3", className);

  return (
    <Tag className={classes} {...restProps}>
      <div className={bem.e("header")}>
        {/* Contenedor principal en fila única */}
        <div className="d-flex justify-content-between align-items-center w-100 mb-3">

          {/* LADO IZQUIERDO: Título + Breadcrumbs uno al lado del otro */}
          <div className="d-flex align-items-center">
            {title && typeof title === "string" ? (
              <Typography type="h1" className={`${bem.e("title")} mb-0 mr-3 me-3`}>
                {title}
              </Typography>
            ) : (
              title
            )}

            {breadcrumbs && (

              <Breadcrumb className={bem.e("breadcrumb")}>

                <Link to={`/principal`} className="btn-color-main">

                  <BreadcrumbItem>Inicio /</BreadcrumbItem>

                </Link>

                {breadcrumbs.length &&

                  breadcrumbs.map(({ name, active, link, url }, index) => (

                    link ? <Link key={'bread' + index} to={`${url}`}>

                      <BreadcrumbItem> &nbsp;{name} /</BreadcrumbItem>

                    </Link> :

                      <BreadcrumbItem key={'bread' + index} active={active}>

                        &nbsp;{name}

                      </BreadcrumbItem>



                    /*<BreadcrumbItem key={index} active={active}>
    
                      &nbsp;{name}
    
                    </BreadcrumbItem>*/

                  ))}

              </Breadcrumb>
            )}
          </div>

          {/* LADO DERECHO: Botón de acción */}
          {action && <div className={bem.e("action")}>{action}</div>}

        </div>
      </div>

      {children}
    </Tag>
  );
};

Page.propTypes = {
  tag: PropTypes.component,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  children: PropTypes.node,
  action: PropTypes.node,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      active: PropTypes.bool
    })
  )
};

Page.defaultProps = {
  tag: "div",
  title: ""
};

export default Page;